

// Template Dashboard 2 MUI Base Styles
import colors from "assets/theme-dark/base/colors";
import typography from "assets/theme-dark/base/typography";
import borders from "assets/theme-dark/base/borders";

// Soft UI Dashboard PRO helper functions
import pxToRem from "assets/theme-dark/functions/pxToRem";

const { dark, background, grey, inputColors, white, light } = colors;
const { size, fontWeightRegular } = typography;
const { borderWidth, borderRadius } = borders;

const inputBase = {
  styleOverrides: {
    root: {
      color: `${white.main} !important`,
      backgroundColor: `${background.dark} !important`,
      "& .MuiSvgIcon-root": {
        color: light.main,
      },

    },

    input: {

      "&::-webkit-input-placeholder": {
        color: `${white.main} !important`,
      },
      "&.Mui-disabled": {
        "-webkitTextFillColor": `${light.main}`,
      },
    },
  },
};

export default inputBase;
